module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tv-fd2caae1fd2cb51b675a3189221b978c.svg";